module.exports = __webpack_public_path__ + "media/information/box-cta-300-e24a2908.jpeg";